import { useEffect } from "react";

export function useScript(url: string) {
    function exist(): boolean {
        const tags = document.getElementsByTagName("script");

        for (let i = 0; i < tags.length; i++) {
            const tag = tags.item(i);
            if (!tag) continue;
            if (tag.src === url) return true;
        }

        return false;
    }

    useEffect(() => {
        if (exist()) return;

        const script = document.createElement("script");

        script.src = url;
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [url]);
}
